import script from "./PractitionerPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PractitionerPage.vue?vue&type=script&lang=ts&setup=true"

import "./PractitionerPage.vue?vue&type=style&index=0&id=6538e106&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6538e106"]])

export default __exports__